import { object } from "prop-types";
import React, { useEffect, useState } from "react";
import useViewPort from "../../../hook/useViewPort";
import { Link, ResponsiveImage } from "@quintype/components";
import "./big-section-hero-image.m.css";
import { userFavouritesApi, validateFavLimit } from "../../../components/utils/user-favourites-api";
import { currentUser } from "@quintype/bridgekeeper-js";
import get from "lodash/get";
import { useSelector } from "react-redux";
import SocialShare from "../social-share";
import { getCollections } from "../../../../api/utils";

const BigSectionHeroImage = ({ data }) => {
  let activeSectionStories = data?.firstSectionStories?.length ? data.firstSectionStories : null;
  const storyObj = activeSectionStories?.[0].story || null;
  const collectionMetaData = data?.collection?.metadata ?? null;
  const [shareUrl, setShareUrl] = useState("");

  const [favSelected, setFevSelected] = useState(false);
  const [userId, setUserId] = useState(null);
  const [isFavLimitExceeded, setFavLimitExceeded] = useState(false);

  // init misc metadata
  const ageRestriction = collectionMetaData?.["age-restriction"]?.[0].name || null;
  const strContentType = collectionMetaData?.["content-type"]?.[0]?.name?.toLowerCase() || null;

  // init image-related things
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const defaultImage = get(qtConfig, ["publisher-attributes", "defaultImageKey"], "");
  const homeImageTemp = collectionMetaData?.webhero || defaultImage;
  const homeImage = decodeURIComponent(
    homeImageTemp.replace(/^https?:\/\/[^/]+\/?/, '').replace(/\?.*$/, '')
  );

  const socialImageTemp = collectionMetaData?.mobiilihero || defaultImage;
  const socialImage = decodeURIComponent(
    socialImageTemp.replace(/^https?:\/\/[^/]+\/?/, '').replace(/\?.*$/, '')
  );
  const imgKeys = [socialImage, homeImage, homeImage];
  const qtConfigSections = useSelector((state) => get(state, ["qt", "config", "sections"], {}));
  useEffect(() => {
    const fetchUserId = async () => {

      try {
        const currentUserResp = await currentUser();
        const userId = currentUserResp?.user?.id || null;
        setUserId(userId);
      } catch (error) {
        console.error("Error fetching user id:", error);
      }
    };

    fetchUserId();
  }, []);

  const { currentImageIndex } = useViewPort();
  const favSectionID = storyObj?.sections?.[0]?.["parent-id"] ?? storyObj?.sections?.[0]?.id ?? null;

  useEffect(() => {
    if (!userId) return;

    const fetchFavoriteStatus = async () => {
      try {
        const responseData = await userFavouritesApi(userId);
        if (!responseData) {return;}
        const favSectionObj = qtConfigSections.find(sec => sec.id === favSectionID);
        const intCollectionID = favSectionObj?.collection?.id || "";
        const isFavFlagSelected = responseData && Array.isArray(responseData) && responseData.some(item => item.asset_id == intCollectionID);

        if (isFavFlagSelected) {
          setFevSelected(true);
        }
      } catch (error) {
        console.error("Error fetching favorite status:", error);
      }
    };

    fetchFavoriteStatus();
  }, [userId]);

  const handleFavBtn = async () => {
    if (!userId) return;

    try {
      // before adding new fav, let's check if limit not exhausted
      if (!favSelected) {
        const isAllowed = await validateFavLimit(userId);

        if (!isAllowed) {
          setFavLimitExceeded(true);
          return;
        }
      }

      // before adding, let's prepare metadata variable
      let objMetadata={};
      const favSectionObj = qtConfigSections.find(sec => sec.id === favSectionID);
      const strCollectionSlug = favSectionObj?.collection?.slug || "";
      let collectionDetails = null;

      if (strCollectionSlug) {
        collectionDetails = await getCollections(strCollectionSlug);
        objMetadata["id"] = collectionDetails?.id || null;
        objMetadata["slug"] = collectionDetails?.slug || null;

        // loop through the metadata properly of the collectionDetails, and assign each key and value to objMetadata
        if (collectionDetails?.metadata) {
          Object.keys(collectionDetails.metadata).forEach(key => {
            objMetadata[key] = collectionDetails.metadata[key] || "";
          });
        }
      }

      const apiUrl = (favSelected ? "/user-favourites/delete"  : "/user-favourites/create");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId, asset_id: objMetadata?.id || null, metadata: objMetadata })
      });

      if (!response.ok) {
        throw new Error("Failed to update favorite status");
      }

      setFevSelected(!favSelected);
    } catch (error) {
      console.error("Error updating favorite status:", error);
      setFevSelected(!favSelected);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setShareUrl(`${window.location.href}`);
    }
  }, [storyObj?.slug]);

  return storyObj && (
    <div styleName="container for-top-shadow" style={{marginTop: "0"}}>
      <div styleName="image-wrapper" className="">
        <div styleName="responsive-image">
          <Link href={`/${storyObj.slug}`}>
            <figure>
              <ResponsiveImage
                aspectRatio={[16, 9]}
                defaultWidth={480}
                widths={[250, 480, 640]}
                slug={imgKeys[currentImageIndex]}
                alt={storyObj.headline}
              />
            </figure>
          </Link>
        </div>
        <div styleName="overlay">
          <div styleName="">
            <div styleName="section-info">
            <h2>{storyObj.headline}</h2>
            <p>{storyObj.subheadline}</p>
            </div>
            <div styleName="overlay-buttons">
              <Link href={`/${storyObj.slug}`} styleName="btn-1">
                {strContentType == "audio" &&
                <div styleName="podcast-btn-wrapper">
                  <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon" />
                  <p style={{fontWeight: "600"}}>Kuuntele</p>
                </div>}
                {strContentType == "video" &&
                  <div styleName="podcast-btn-wrapper">
                  <img alt="audio-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                  <p style={{fontWeight: "600"}}>Katsele</p>
                </div>}
                {strContentType == "" &&
                  <div styleName="podcast-btn-wrapper">
                  <img alt="audio-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                  <p style={{fontWeight: "600"}}>Katsele</p>
                </div>}
              </Link>
              <div styleName="button-wrapper">
                {userId > 0 && (
                  favSelected ? (
                    <div styleName="btn-2 add-to-fav-btn">
                      <div style={{display: "flex"}} onClick={handleFavBtn}>
                        <img alt="audio-logo" src="/icons/favorites-symbol-added-white.svg"  styleName="custom-img-icon"/>
                        <p>&nbsp;Omat suosikit</p>
                      </div>
                    </div>
                  ) : (
                    <div styleName="btn-2 add-to-fav-btn">
                      <div style={{display: "flex"}} onClick={handleFavBtn}>
                        <img alt="audio-logo" src="/icons/favorites-symbol-white.svg"  styleName="custom-img-icon"/>
                        <p>&nbsp;Omat suosikit</p>
                      </div>
                    </div>
                  )
               )}
               {ageRestriction=== "15" &&<div styleName="k-16">
                  <p>K15</p>
                </div>}
               {ageRestriction=== "18" &&<div styleName="k-16">
                  <p>K18</p>
                </div>}
                <div styleName="btn-2 jaa">
                  {shareUrl && (
                    <SocialShare url={shareUrl} defaultText="" btnStyle="small" />
                  )}
                </div>
              </div>
              {isFavLimitExceeded && (
                <div style={{ color: "white", marginTop: "10px", backgroundColor: "#333", padding: "10px", borderRadius: "5px" }}>
                  Olet saavuttanut suosikkien enimmäismäärän (20)! Lisätäksesi uuden suosikin, poista ensin jokin nykyisistä suosikeistasi.
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
      </div>
  );
};

BigSectionHeroImage.propTypes = {
  data: object
};

export default BigSectionHeroImage;
